export const checkinmanual = {
    text1: "Manueller Check-in",
    text2: "Geben Sie die für die Gästeregistrierung erforderlichen Daten ein.",
    text3: "Angaben zur Unterkunft",
    text4: "Unterkunft auswählen *",
    text5: "Persönliche Daten",
    text6: "Vorname des Gastes *",
    text7: "Nachname des Gastes *",
    text8: "Männlich",
    text9: "Weiblich",
    text10: "Keine Angabe",
    text11: "Divers",
    text12: "Geschlecht auswählen *",
    text13: "Geburtsdatum *",
    text14: "Telefonnummer *",
    text15: "Angaben zum Aufenthalt",
    text16: "Die Angaben zum Aufenthalt sind für den Check-in zwingend erforderlich. Bitte füllen Sie alle Felder aus.",
    text17: "Von - Bis",
    text18: "Bis zu welchem Datum bleibt der Gast?",
    text19: "E-Mail des Gastes *",
    text20: "Dokumentart auswählen.",
    text21: "Personalausweis",
    text22: "Reisepass",
    text23: "Dokumentart",
    text24: "Dokumentnummer",
    text25: "Geben Sie die Dokumentnummer ein",
    text26: "Ablauf des Dokuments",
    text27: "Ablauf des Dokuments",
    text28: "Weiter",
    text29: "Manueller Check-in",
    text30: "Geben Sie die für die Gästeregistrierung erforderlichen Daten ein.",
    text31: "Unterschrift zum Check-in",
    text32: "Unterschreiben Sie in dem grauen Feld auf dem Bildschirm",
    text33: "Check-in speichern",
    text34: "Check-in erfolgreich abgeschlossen.",
    text35: "Sie müssen eine Unterkunft auswählen, der der Check-in zugeordnet wird",
    text36: "Das Feld Vorname ist erforderlich",
    text37: "Das Feld Nachname ist erforderlich",
    text38: "Das Feld Geschlecht ist erforderlich",
    text39: "Das Feld Geburtsdatum ist erforderlich",
    text40: "Das Feld Telefon ist erforderlich",
    text41: "Das Feld Aufenthaltsdatum ist erforderlich",
    text42: "Das Feld E-Mail ist erforderlich",
    text43: "Das Feld Land ist erforderlich",
    text44: "Das Feld Dokumentart ist erforderlich",
    text45: "Das Feld Dokumentnummer ist erforderlich",
    text46: "Sie müssen die Allgemeinen Geschäftsbedingungen akzeptieren.",
    text47: "Check-in-Daten werden gesendet, bitte warten...",
    text48: "Wird geladen...",
    text49: "Check-in erfolgreich abgeschlossen.",
    text50: "Klicken Sie hier, um alle verfügbaren Services im Hotel zu sehen",
    text51: "Vorname eingeben",
    text52: "Nachname eingeben",
    text53: "Land",
    text54: "Fehler",
    text55: "E-Mail-Adresse eingeben",

    // Corrections
    p1: "Check-in-Datum",
    p2: "Check-out-Datum",
    p3: "Ausstellungsdatum des Dokuments",
    p4: "",
    p5: "",
    p6: "",
    p7: "",
    p8: "",
};
